//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <i-menu :active-name="currentUrlAsMainMenuItemId" :open-names="[2]" theme="dark" width="auto" @on-select="mainMenuItemSelect">
    <MainMenuItems :data="mainMenu" :lvl="1" :deleteItemOnClick='mainMenuDeleteItem'/>
  </i-menu>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import MainMenuItems from './MainMenuItems.vue'
import mainMenuMaker from './mainMenuMaker'

export default {
  name: 'MainMenu',
  components: { MainMenuItems },
  created: function () {
    this.$emit('returninstance', this) // возвращаем экземпляр компонента, что из-вне можно было вызвать makeMenu
    /* mainMenuMaker.makeMenu(this, function () { // теперь это тут вызывать нельзя потому что при created еще нет данных от бд по MainMenuPermissionsByUserGroups
      return
    }) */
  },
  computed: {
    currentUrlAsMainMenuItemId () {
      var currentMenuItem = this.mainMenuFindItemByPath(this.$route.path)
      if (currentMenuItem !== null) {
        return currentMenuItem.id
      }
      return -1
    },
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData',
      'mainMenu',
      'mainMenuFindItemByPath',
      'mainMenuFindItemById'
    ])
  },
  methods: {
    // метод сдела чтобы вызывать makeMenu не в created а когда пришли данные от бд, включая settings такие как MainMenuPermissionsByUserGroups
    makeMainMenu: function () {
      mainMenuMaker.makeMenu(this, function () {
        return
      })
    },
    mainMenuItemSelect (menuItemId) {
      var selectedMenuItem = this.mainMenuFindItemById(menuItemId)
      if ((selectedMenuItem !== null) && (selectedMenuItem.path != null)) {
        this.$router.push(selectedMenuItem.path)
      }
    },
    ...mapMutations([
      'activeUserSet',
      'mainMenuSet',
      '_mainMenuDeleteItem' // только для MainMenuMaker временно чтобы спагеттикод не писать для удаления пунктов
    ]),
    ...mapActions([
      'mainMenuDeleteItem'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
@import "./MainMenu.css";
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainMenu.vue?7bbe0624